import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 900px;
  margin: 20px auto;
  padding: 20px;
  font-family: 'Inter', sans-serif;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 30px;
`;

const Card = styled(Link)`
  background: white;
  padding: 30px;
  border-radius: 16px;
  text-decoration: none;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
  transition: all 0.2s;
  border: 1px solid #eee;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0,0,0,0.1);
    border-color: #1976d2;
  }

  .icon { font-size: 3rem; }
  h3 { margin: 0; font-size: 1.2rem; }
  p { margin: 0; color: #666; text-align: center; font-size: 0.9rem; }
`;

function Configuracion() {
  return (
    <Container>
      <Grid>
        {/* <Card to="/docentes">
          <span className="icon">👨‍🏫</span>
          <h3>Docentes</h3>
          <p>Administrar personal, CI, especialidades y datos básicos.</p>
        </Card> */}
        <Card to="/periodos">
          <span className="icon">🕒</span>
          <h3>Periodos</h3>
          <p>Definir los turnos y horarios de entrada/salida (Periodos).</p>
        </Card>
        <Card to="/horarios">
          <span className="icon">📝</span>
          <h3>Asignación</h3>
          <p>Asignar periodos y días de trabajo a cada docente.</p>
        </Card>
      </Grid>
    </Container>
  );
}

export default Configuracion;
